import React, { useState, useEffect } from 'react';

import { Card } from "semantic-ui-react";
import Switch from "./settings/Switch";
import DropdownSelect from "./settings/DropdownSelect";
import MultiOptions from "./settings/MultiOptions";
import ButtonSupport from "./settings/ButtonSupport";
import Import from './settings/Import';

import { defaultSettings, getComponentValue } from "./settings/Config";

function SettingsTab(props) {

    if (!localStorage.getItem("settings")) {
        localStorage.setItem("settings", JSON.stringify(defaultSettings));
    }

    const [settings, setSettings] = useState(JSON.parse(localStorage.getItem("settings")));
    const [idSetting, setIdSetting] = useState(JSON.parse(localStorage.getItem("settings")));
    const [valueSetting, setValueSetting] = useState(JSON.parse(localStorage.getItem("settings")));
    const [childId, setChildId] = useState(null);
    const [lang, setLang] = useState(getComponentValue("language"));

    function handleChangeLang(value) {
        setLang(value);
    }

    function handleChange(id, value, child) {
        if (child !== undefined) {
            setChildId(child);
        } else {
            setChildId(null);
        }
        setIdSetting(id);
        setValueSetting(value);
        if (id === "language") {
            setLang(value);
        }
    }

    function handleNewImport(newBackgrounds, newFavorites, newSettings) {
        if (newBackgrounds) {
            props.newImportBackgrounds();
        }
        if (newFavorites) {
            props.newImportFavorites();
        }
        if (newSettings) {
            window.location.reload();
        }
    }

    useEffect(() => {
        let sett = settings;
        for (const item of sett) {
            if (item.id === idSetting) {
                if (childId) {
                    for (const itemConfig of item.config) {
                        if (itemConfig.id === childId) {
                            itemConfig.value = valueSetting;
                        }
                    }
                } else {
                    item.value = valueSetting;
                }
                break;
            }
        }
        props.onChangeLang(lang);
        props.onChange(settings);
        localStorage.setItem("settings", JSON.stringify(settings));
        setSettings(JSON.parse(localStorage.getItem("settings")));
    }, [idSetting, valueSetting, childId]);


    return (
        <div id="tab-settings" className="tab">
            {settings.map((item, index) => {
                if (item.component === "switch") {
                    return (<Card key={index} className="card-settings" fluid color={item.color} header={<Switch onChange={handleChange} lang={lang} data={item} />} />);
                } else if (item.component === "dropdown") {
                    return (<Card key={index} className="card-settings" fluid color={item.color} header={<DropdownSelect onChangeLang={handleChangeLang} onChange={handleChange} lang={lang} data={item} />} />);
                } else if (item.component === "multioptions") {
                    return (<Card key={index} className="card-settings" fluid color={item.color} header={<MultiOptions onChange={handleChange} lang={lang} data={item} />} />);
                } else if (item.component === "import") {
                    return (<Card key={index} className="card-settings" fluid color={item.color} header={<Import lang={lang} data={item} onChangeImport={handleNewImport} />} />);
                } else if (item.component === "buttonSupport") {
                    return (<Card key={index} className="card-settings" fluid color={item.color} header={<ButtonSupport lang={lang} data={item} />} />);
                } else {
                    return null;
                }
            })}
        </div>
    );
}

export default SettingsTab;